import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

import "./RequestNewTestRedirectModal.css";

export default function RequestNewTestRedirectModal({
  open,
  loading = false,
  onContinueForm,
  onAddNewTest,
}) {
  if (!open) return null;

  return (
    <Modal
      open
      closable={!loading}
      centered
      footer={null}
      width={560}
      wrapClassName="RequestNewTestRedirectModal"
      className="RequestNewTestRedirectModal"
      closeIcon={<CloseOutlined className="SampleSubmissionModal__closeIcon" />}
      onCancel={loading ? undefined : onContinueForm}
      maskClosable={!loading}
      destroyOnHidden
    >
      <div className="RequestNewTestRedirectModal__content">
        <div className="RequestNewTestRedirectModal__message">
          <p className="RequestNewTestRedirectModal__heading">
            You&apos;ll be redirected to the
            {" "}
            <span className="RequestNewTestRedirectModal__headingHighlight">Add New Test form.</span>
            {" "}
            Your currently added samples will be saved as a draft.
          </p>
        </div>
        <div className="RequestNewTestRedirectModal__actions">
          <Button
            type="default"
            htmlType="button"
            disabled={loading}
            onClick={onContinueForm}
          >
            Continue Current Form
          </Button>
          <Button
            type="primary"
            htmlType="button"
            loading={loading}
            onClick={onAddNewTest}
          >
            Add New Test
          </Button>
        </div>
      </div>
    </Modal>
  );
}
